import { Component, TemplateRef, effect, inject, input, output } from '@angular/core';
import { EntitySharedModule } from '@app/modules/entity.shared.module';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'mobi-overlay-small',
  templateUrl: './overlay-small.component.html',
  styleUrls: ['./overlay-small.component.scss'],
  standalone: true,
  imports: [EntitySharedModule, MobiUiIconComponent],
})
export class OverlaySmallComponent {
  readonly content = input.required<TemplateRef<any>>();
  readonly isOpen = input(false);
  readonly closeOverlay = output();

  #doc = inject(DOCUMENT);

  #stateChange = effect(() => {
    if (this.isOpen()) this.#doc.documentElement.classList.add('no-scroll');
  });

  onCloseOverlay() {
    this.#doc.documentElement.classList.remove('no-scroll');
    this.closeOverlay.emit();
  }
}
